// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: '모두',
  AllDocuments: '모든 문서',
  Any: '어느',
  Today: '오늘',
  Yesterday: '어제',
  LastWeek: '지난주',
  LastMonth: '전달',
  DateFrom: '에서',
  DateTo: '에게',
  DateRange: '날짜 범위',
  NeverViewed: '마지막으로 본 이후로 본 적이 없거나 변경되지 않음',
  AddedLastLogin: '마지막 로그인 이후 추가 또는 변경됨',
  GlobalNetworkErrorMessage:
    '네트워크에 문제가 있습니다. 다시 시도하거나 지원팀에 문의하세요.',
  GlobalIntermediateProxyErrorMessage:
    '귀하의 네트워크가 데이터룸에 대한 이 요청을 가로챘습니다. IT 부서에 문의하세요.',
  GlobalUnexpectedErrorWithIdMessage:
    '데이터룸에 문제가 있습니다. 이 코드 \u003c[ErrorId]\u003e를 고객 서비스 팀에 인용하세요.',
  GlobalUnexpectedErrorMessage:
    '데이터룸에 문제가 있습니다. 고객 서비스 팀에 문의하세요.',
  NoRecordsFound: '기록을 찾을 수 없습니다.',
  Save: '구하다',
  Print: '인쇄',
  ViewAs: '보기로 보기',
  Documents: '서류',
  Date: '날짜',
  HideEmptyFolders: '빈 폴더 숨기기',
  Search: '찾다',
  Actions: '행위',
  Filter: '필터',
  Self: '너',
  Allowed: '허용된',
  Denied: '거부됨',
  PleaseEnterValidToDate: '유효한 날짜를 입력하세요.',
  PleaseEnterValidFromDate: '유효한 시작 날짜를 입력하세요.',
  SavingAllowed: '저장이 허용되었습니다',
  SavingDenied: '저장 거부됨',
  PrintingAllowed: '인쇄 허용',
  PrintingDenied: '인쇄 거부',
  ChooseLanguage: '언어 선택',
  EditProfile: '프로필 편집',
  DataRooms: '데이터 룸',
  Administration: '관리',
  MyAccount: '내 계정',
  Profile: '윤곽',
  Logout: '로그아웃',
  Loading: '로딩중',
  Success: '성공',
  Disabled: '비활성화됨',
  Ok: '좋아요',
  And: '그리고',
  Demo: '데모',
  TenderSubmissionsStart: '제출 프로세스 시작',
  TenderSubmissionsOverdue:
    '제출 프로세스가 종료되었습니다. 지금 업로드하는 문서는 늦은 것으로 표시됩니다.',
  TenderSubmissionsClose: '제출 프로세스가 종료되었습니다.',
  Later: '나중에',
  StartNow: '지금 시작하세요',
  StartSubmissionDialogTitle: '제출 프로세스 시작',
  StartSubmissionDialogContent:
    '입찰자에게는 문서를 업로드하고 볼 수 있다는 알림이 전달됩니다. ' +
    "제출 프로세스 중에는 내부 팀이 문서에 액세스할 수 없습니다.",
  StartSubmissionDialogCloseDateContent:
    '제출 프로세스는 ${closeDate} 에 종료됩니다.',
  SubmissionInformationIsIncomplete: '제출 정보가 불완전합니다. ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    '입찰자는 초대되지 않았거나 제거되었습니다. ',
  InviteBidderTeams: '입찰자 초대',
  UpdateSecuritySettings: '보안 설정 업데이트',
  UpdateTheirSecuritySettings: '보안 설정을 업데이트합니다.',
  OnTimeSubmission: '정시에 제출',
  LateSubmission: '늦은 제출',
  DeleteAllDocuments: '모든 제출 문서를 삭제합니다.',
  Manage: '관리하다',
  ManageSubmissions: '제출물 관리',
  NotStarted: '시작되지 않음',
  Closed: '닫은',
  ExtraTime: '추가 시간에',
  Open: '열려 있는',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    '입찰자 제출에 대한 구조를 만들고 마감일을 설정합니다.',
  AddSubmissionWindow: '제출 창 추가',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 명의 입찰자는 제출물을 추가할 권한이 없습니다.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    '${totalBidders} 입찰자는 제출물을 추가할 권한이 없습니다.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} ${totalDocsCount} 문서',
  BulkRedactionMarksToRedact: '${selectedMarksCount} 삭제할 항목',
  BulkRedactionMarksRedacted: '${redactionMarksCount} 항목이 삭제됨',
  BulkRedactionSkipAndNext: '문서 건너뛰기',
  BulkRedactionSkipAndFinish: '건너뛰고 편집을 완료하세요',
  BulkRedactionSaveAndNext: '저장 및 다음 문서',
  BulkRedactionSaveAndFinish: '저장하고 편집을 완료하세요',
  BulkRedactionRedactAllRemainingDocuments:
    '모든 ${documentsRemaining} 문서를 삭제합니다.',
  BulkRedactionCancel: '취소',
};
